export default __webpack_public_path__ + "static/media/logo.e4df1991.png";